import { InjectionToken } from '@angular/core';

export interface TwcPluginEnvironment {
  apiKey: string;
}
export const TWC_CONFIG_TOKEN = new InjectionToken<
  Partial<TwcPluginEnvironment>
>('TWC_CONFIG_TOKEN');
